module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/wearing/wearing-12-ca296853976e8474b4e6d7de6dc71a2d.jpg";